import { useSelector } from 'react-redux';
import { Field } from 'formik';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import TrunkFieldRow from './TrunkFieldRow';

const SRTTrunkNameField = ({ isInvalid }) => {
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <TrunkFieldRow
            label="Trunk Name"
            tooltip="The display name for this trunk"
            ariaLabel="trunk-name-tip"
            isInvalid={isInvalid}>
            <Field
                name="name"
                component={NameField}
                darkMode={darkMode}
                placeholder="Enter trunk name"
            />
        </TrunkFieldRow>
    );
};

export default SRTTrunkNameField;
